import DrawerAppBar from '../components/nav';
import Pacman from '../sections/pacman';
import About from '../sections/About';
import Partner from '../sections/partners';
import Tokenomics from '../sections/Tokenomics';
import Faq from '../sections/faq';
import Footer from '../components/footer';
import RoadMap from '../sections/roadmap';

function Home() {
  return (
    <>
        <DrawerAppBar />
        <Pacman />
        <About />
        <Partner />
        <Tokenomics />
        <RoadMap />
        <Faq />
        <Footer />
    </>

  );
}

export default Home;
